import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Experience from './components/Experience/Experience';
import ProfessionalWork from './components/ProfessionalWork/ProfessionalWork';
import Projects from './components/Projects/Projects';
import OpenSource from './components/OpenSource/OpenSource';
import Skills from './components/Skills/Skills';
import Education from './components/Education/Education';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import AnalyticsController from './analytics/AnalyticsController';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';

function App() {
  if (window.location.pathname === '/admin') return <AdminDashboard />;
  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <Header />
      <main id="main-content">
        <Hero />
        <About />
        <Experience />
        <ProfessionalWork />
        <Projects />
        <OpenSource />
        <Skills />
        <Education />
        <Contact />
      </main>
      <Footer />
      <AnalyticsController />
    </>
  );
}

export default App;
